import { useMemo } from 'react';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { selectCreditScoreBands } from '../selectors';
const palette = (g) => ({
    light: g.colorVariant?.light ?? g.colors[0],
    mid: g.colors[0],
    dark: g.colorVariant?.dark ?? g.colors[0],
});
const useDefaultScoreBands = () => {
    const colors = useColors();
    const bands = useAppSelector(selectCreditScoreBands);
    return useMemo(() => {
        const palettes = [
            palette(colors.gradients.deepPink),
            palette(colors.gradients.apricot),
            palette(colors.gradients.yellow),
            palette(colors.gradients.lime),
            palette(colors.gradients.forest),
        ];
        const gradientStopsByIndex = [
            [
                [0, palettes[0].dark],
                [0.89, palettes[0].mid],
                [1, palettes[0].light],
            ],
            [
                [0, palettes[1].dark],
                [0.67, palettes[1].mid],
                [1, palettes[1].light],
            ],
            [
                [0, palettes[2].dark],
                [0.36, palettes[2].dark],
                [0.68, palettes[2].mid],
                [1, palettes[2].light],
            ],
            [
                [0, palettes[3].dark],
                [0.09, palettes[3].dark],
                [0.55, palettes[3].mid],
                [1, palettes[3].light],
            ],
            [
                [0, palettes[4].dark],
                [0.5, palettes[4].mid],
                [1, palettes[4].light],
            ],
        ];
        return bands.map((band, i) => {
            const idx = Math.min(i, palettes.length - 1);
            return {
                ...band,
                midColor: palettes[idx].mid,
                gradientStops: gradientStopsByIndex[idx],
            };
        });
    }, [bands, colors]);
};
export default useDefaultScoreBands;
